import { reportError } from "../../../utils/sentry-reporter";

const EDIT_BOX_REPORT_COMPONENT = "edit_box";

export function reportEditBoxFailure(error: unknown, step: string): void {
    reportError(error, { extra: { component: EDIT_BOX_REPORT_COMPONENT, step } });
}
